import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Combos/getInstalacionesPadreOSinHijos`, method: 'GET', body: null, token: token})
}